import { CircularProgress } from '@mui/material';
import Button from '@mui/material/Button';
import { usePathname } from 'next/navigation';
import { useCallback, useState } from 'react';
import { connectField } from 'uniforms';

export const ImageUploader = connectField(
  ({ value, onChange, label, imageUpload }: any) => {
    const path = usePathname();
    const [showLoading, setShowLoading] = useState(false);
    const results: { tenantId: string; companyId: string; screenId: string } =
      parseUrl(path)!;

    const handleImageChange = useCallback(
      async (e: any) => {
        e.preventDefault();
        const file = e.target.files[0];
        setShowLoading(true);
        if (file && results) {
          const data = await imageUpload(file);

          if (data.url) {
            onChange(data.url);
          }
          setShowLoading(false);
        }
      },
      [results?.tenantId, results?.companyId] // dependencies
    );

    return (
      <div className="flex-center-align" style={{ marginTop: 10 }}>
        <label htmlFor="textAlignSelect">{label}</label>
        <div style={{ marginLeft: 5, paddingTop: 5 }}>
          <input
            accept="image/*"
            // className={classes.input}
            style={{ display: 'none' }}
            id="raised-button-file"
            type="file"
            onChange={handleImageChange}
          />
          <label htmlFor="raised-button-file">
            <Button disabled={showLoading} variant="contained" component="span">
              Upload {showLoading && <CircularProgress size={'small'} />}
            </Button>
          </label>
        </div>
      </div>
    );
  }
);

function parseUrl(url: string) {
  const regex = url.includes('edit')
    ? /\/admin\/tenants\/(\d+)\/companies\/(\d+)\/screens\/create\/edit\/(\d+)/
    : /\/admin\/tenants\/(\d+)\/companies\/(\d+)\/screens\/create(\/(\d+))?/; // Optional ID in create mode

  const match = RegExp(regex).exec(url);
  if (match) {
    const tenantId = match[1];
    const companyId = match[2];
    const screenId = url.includes('edit') ? match[3] : match[4] || ''; // screenId only for edit mode or optional in create
    return { tenantId, companyId, screenId };
  } else {
    return null;
  }
}
